import { styled } from '@mui/material'
import MuiTabs from '@mui/material/Tabs'

export type { TabsProps } from '@mui/material'

const Tabs = styled(MuiTabs)(({ theme }) => ({
  borderBottom: `1px solid ${theme.palette.divider}`,
}))

export default Tabs
